import { PayableSubjectType } from '../types/payableSubjectType'

export const getReferenceFromSubject = (id: string, type?: PayableSubjectType | null) => `${type}:${id}`
